import type { ReactNode } from 'react';

export const symbol_stairs_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-200q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-260 110-260h217v-220q0-12.75 8.63-21.38Q344.25-510 357-510h216v-220q0-12.75 8.63-21.38Q590.25-760 603-760h247q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H633v220q0 12.75-8.62 21.37Q615.75-450 603-450H387v220q0 12.75-8.62 21.37Q369.75-200 357-200H110Z"
		/>
	</svg>
);
